// @flow

import alt from '../alt';

class SoftwareUpdateActions {
	/**
	 * Algatatakse tarkvara info laadimine serverist
	 */
	fetchSoftwareInfo(user, passwd) {
		return {user: user, passwd: passwd};
	}

	/**
	 * Info laadimine ebaõnnestus
	 */
	fetchSoftwareInfoFailed(error) {
		return error;
	}

	/**
	 * Info sai laetud
	 */
	fetchSoftwareInfoDone(data) {
		return data;
	}

	/**
	 * Tarkvara uuendamine
	 * @param file Uuendusfail
	 * @returns {*}
	 */
	update(file, user, passwd) {
		return {file: file, user: user, passwd: passwd};
	}
	
	/**
	 * Uuendamine ebaõnnestus
	 */
	updateFailed(error) {
		return error;
	}
	
	/**
	 * Uuendamine edukalt lõpetatud
	 */
	updateDone(data) {
		return data;
	}

	/**
	 * Vana tarkvaraversiooni taastamine
	 */
	restore(user, passwd) {
		return {user: user, passwd: passwd};
	}

	/**
	 * Tarkvaraversiooni taastamine ebaõnnestus
	 */
	restoreFailed(error) {
		return error;
	}
	
	/**
	 * Tarkvaraversioon sai taastatud
	 */
	restoreDone() {
		return null;
	}
}

export default alt.createActions(SoftwareUpdateActions);
